import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IQueueStatisticsPayload } from '@app-store/slices/reporting/queueStatistics'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IQueueStatisticsPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.reporting.queueStatistics

function* queueStatisticsSagaTask({ payload }) {
    try {
        const response = yield axios.get(
            `/companies/queue-processor?query={"matchListGroupId":"${payload.matchListGroupId}"}`
        )
        if (response) {
            yield put(onSuccess(response))
            yield payload?.sagaCB?.onSuccess(response)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* queueStatisticsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, queueStatisticsSagaTask)
}

export default queueStatisticsSaga
